<template>
  <div>
    <div class="cart">
      <div class="left-sidebar">
        <div class="left-sidebar__header">
          <img src="/static/img/pictos/panier.svg" class="">
          <span>Mon Panier</span>
        </div>
      </div>
      <div class="content-area">
        <h1>Je confirme mon adresse de livraison</h1>
        <div class="filters">
          <input class="filter" type="text" name="" placeholder="Rechercher par technicien">
        </div>
        <form class="form">
          <label>Nom</label>
          <input type="text" value="" placeholder="Doe" name="lasname" class="field">
          <label>Prénom</label>
          <input type="text" value="" placeholder="John" name="firstname" class="field">
          <label>Email</label>
          <input type="email" value="" placeholder="john.doe@mail.fr" name="email" class="field">
          <label>Adresse</label>
          <input type="text" value="" placeholder="Point relais XXX, 4 rue des prés, bâtiment A" name="address" class="field">
          <div class="field-row">
            <div class="field-column">
              <label>Ville</label>
              <input type="text" value="" placeholder="Rennes" name="city" class="field">
            </div>
            <div class="field-column">
              <label>Code postal</label>
              <input type="text" value="" placeholder="35000" name="zipcode" class="field">
            </div>
          </div>
          <button type="submit" class="submit">
            Je valide la livraison
            <img src="/static/img/pictos/valider.svg" class="">
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>

import CartHeader from "@/components/Cart/CartHeader";

export default {
  name: "CartAddress",
  data() {
    return {

    };
  },
  computed: {
    cart: function() {
      let cart = this.$store.getters["order/getMyCart"];
      return cart.length > 0 ? cart[0] : {lines: null};
    }
  },
  mounted() {
    this.$store.dispatch("order/getMyCart").then(() => (this.isBusy = false));
  },
  methods: {

  },
  components: {
    CartHeader,
  }
};
</script>


<style lang="scss" scoped>
  @import "~@/assets/scss/_colors.scss";

  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: white;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: $grisclair;
    border-radius: 20px;
    height: 5px;
  }

  .cart{ display: flex; }

  .left-sidebar{ width: 300px;
    &__header{ background-color: $color3; display: flex; height: 300px; flex-direction: column; align-items: center; justify-content: center;
      img{ width: 120px; }
      span{ color: white; font-family: 'ClanFFBlack'; font-size: 20px; margin-top: 25px; text-transform: uppercase; }
    }
  }

  .content-area{ width: calc(100% - 300px); padding: 0 7%; margin-top: 80px; margin-right: 50px;
    h1{ font-family: 'ClanFFBlack'; color: $color1; font-size: 25px; margin-bottom: 50px; position: relative; padding-bottom: 30px;
      &:before{ content: ""; display: block; width: 60px; height: 8px; background-color: $color1; border-radius: 4px; position: absolute; bottom: 0; }
    }
  }

  .filters{ display: flex; margin-bottom: 50px; width: 80%;
    .filter{ height: 35px; line-height: 35px;  border: 1px solid $color1; }
    input[type=text]{ width: auto; flex: 1; padding: 0 15px; }
  }

  form{ width: 80%;
    label{ font-family: 'ClanPro'; color: $color1; font-size: 12px; }
    .field{ width: 100%; padding: 0 20px; height: 50px; line-height: 50px; font-size: 12px; margin-bottom: 20px; }
    .field-row{ display: flex; width: 100%; justify-content: space-between; }
    .field-column{ width: calc(50% - 10px); }
    .submit{ margin-top: 50px; background-color: $vert; display: flex; padding: 0 20px; color: white; border: none; font-family: 'ClanProBold'; font-size: 14px; height: 70px; align-items: center;
      img{ width: 30px; margin-left: 20px; }
    }
  }


  @media screen and (max-width: 1300px){
    form{ width: 100%; }
    .filters{ width: 100%; }
  }
</style>



// WEBPACK FOOTER //
// src/components/Cart/CartAddress.vue